import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ChildTile from "../Common/ChildTile";
import ChildStory from "../Common/ChildStory";
import ChildVideo from "./ChildVideo";
import ChildName from "./ChildName";
import ChildBenefits from "./ChildBenefits";
import BackButton from "./BackButton";
import SponsorCta from "../Common/SponsorCta";
import SponsorValue from "../Common/SponsorValue";
import ShareChild from "../Common/ShareChild";
import { childImage, donateLinkBuilder, noFuncProps, toScrollElement, isWebpublishable } from "../../utils/helpers.js";
import { gtmTrackEventData } from "../../utils/gtm-event-triggers";
import { getChildById } from "wvus-sponsorship-engine";
import { statusUpdater } from "wvus-sponsorship-engine/dist";
import { faTimesCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { getAdditionalParams } from "../../utils/app-settings";
import { getSponsorshipMonthlyRate } from "../../config/rates";

class ChildDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      videoUrl: null,
      videoLanguage: null,
      childName: null,
      childImage: null,
      childCountry: null,
      childGender: null,
      childBrithday: null,
      story: [],
    };
  }

  //ONCALL-6576b added a componentDidUpdate lifecycle method to wait for Redux data to populate and then trigger state setup, this is necessary after upgrading React to version 18

  componentDidUpdate(prevProps) {
    const currentChild = this.props.child[this.props.childId];
  
    if (
      this.props.status === "COMPLETE" &&
      currentChild &&
      currentChild !== prevProps.child[this.props.childId]
    ) {
      this.childVideo(this.props.device, currentChild);
      this.storeChildDetailsInState(currentChild);
      this.getChildImage(currentChild, true);
      this.props.animateGrid(false);

      // Fire GTM tracking event for child detail view
      gtmTrackEventData("spon_app_child_detail_view", {
        "child_props": noFuncProps(this.props),
        "search_props": noFuncProps(currentChild),
        "sponsorship_monthly_rate": getSponsorshipMonthlyRate()
      });
    }
  }
  

  componentDidMount() {
    toScrollElement();
    const obj = this.props.child;
    const childParam = this.props.childId;
    const getChildById = this.props.getChildById;

    if (Object.keys(this.props.child).length > 0 && this.props.child.constructor === Object) {
      
      let foundChild = false;
      for (var property in obj) {
        //childId matches a child stored in redux
        if (obj[property].identifier === childParam) {
          // console.log("Object if true: ", obj[property].identifier);
          const identifier = this.props.childId;
          this.childVideo(this.props.device, this.props.child[identifier]);
          this.storeChildDetailsInState(this.props.child[identifier]);
          this.getChildImage(this.props.child[identifier], true);
          foundChild = true;

          // Fire GTM tracking event for child detail view
          gtmTrackEventData("spon_app_child_detail_view", {
            "child_props": noFuncProps(this.props),
            "search_props": noFuncProps(this.props.child[identifier]),
            "sponsorship_monthly_rate": getSponsorshipMonthlyRate()
          });
        }
      }
      //there are children in redux store but they do not match the child Id requested
      if (foundChild === false) {
        this.props.animateGrid(true);
        getChildById(childParam, () => {
          if (this.props.status === "COMPLETE") {
            const identifier = this.props.childId;
            this.childVideo(this.props.device, this.props.child[identifier]);
            this.storeChildDetailsInState(this.props.child[identifier]);
            this.getChildImage(this.props.child[identifier], true);
            this.props.animateGrid(false);

            gtmTrackEventData("spon_app_child_detail_view", {
              "child_props": noFuncProps(this.props),
              "search_props": noFuncProps(this.props.child[identifier]),
              "sponsorship_monthly_rate": getSponsorshipMonthlyRate()
            });
          }
        });
      }
      //no kids in redux
    } else {
      this.props.animateGrid(true);
      getChildById(childParam, () => {
        if (this.props.status === "COMPLETE") {
          const identifier = this.props.childId;
          this.childVideo(this.props.device, this.props.child[identifier]);
          this.storeChildDetailsInState(this.props.child[identifier]);
          this.getChildImage(this.props.child[identifier], true);
          this.props.animateGrid(false);

          gtmTrackEventData("spon_app_child_detail_view", {
            "child_props": noFuncProps(this.props),
            "search_props": noFuncProps(this.props.child[identifier]),
            "sponsorship_monthly_rate": getSponsorshipMonthlyRate()
          });
        }
        this.handleError();
      });
    }

    const hasChildrenCached = !!(this.props.children && Object.keys(this.props.children).length);
    gtmTrackEventData("spon_app_page_view", {
      "display_type": hasChildrenCached ? "vpv" : "pv",
      "title": "child_detail_page"
    });
  
    this.props.fireAnalyticsEvents("childDetail", { childId: childParam, backLink: this.props.backLink });
  }

  getChildImage(props, type) {
    this.setState({
      childImage: childImage(props, type),
    });
  }

  childVideo(device, child) {
    let videoFormat = null;
    device === "desktop" ? (videoFormat = "web") : (videoFormat = "mob");
    const obj = child.childMedia.find((x) => x.contentTypeCode === "CGV" && x.format === videoFormat);
    const hideVideo = !isWebpublishable(child);

    if (obj) {
      this.setState({
        videoUrl: hideVideo ? null : obj.url,
        videoLanguage: child.languageDescription
      });
    }
  }

  storeChildDetailsInState(child) {
    this.setState({
      childId: child.identifier,
      story: child.story,
      childName: child.givenName,
      childCountry: child.countryName,
      childGender: child.gender,
      childBrithday: child.birthdate,
    });
  }

  renderBackLink() {
    if (this.props.backLink === "grid" && this.props.gridWasActive === true) {
      return (
        <BackButton
          classList={"detail__back-to-grid btn-text btn-text-blue btn-small"}
          buttonText="back"
          handleBackButton={this.props.handleBackButton}
          resetGridCalc={this.props.resetGridCalc}
          handleHistory={this.props.handleHistory}
        />
      );
    } else if (this.props.backLink === "cart") {
      return false;
    } else {
      return (
        <BackButton
          classList={"detail__back-to-grid btn-text btn-text-blue btn-small"}
          buttonText="search"
          handleBackButton={this.props.handleBackButton}
          resetGridCalc={this.props.resetGridCalc}
          handleHistory={this.props.handleHistory}
        />
      );
    }
  }

  renderExploreMoreLink() {
    if (this.props.backLink === "cart") {
      return false;
    } else {
      return (
        <BackButton
          classList={"detail__explore-more-children btn-secondary"}
          buttonText="view more children"
          handleBackButton={this.props.handleBackButton}
          resetGridCalc={this.props.resetGridCalc}
          handleHistory={this.props.handleHistory}
        />
      );
    }
  }

  handleError() {
    if (this.props.status == "ERROR") {
      // this.props.statusUpdater("EDITING");
      this.props.toggleErrorMessage(true, {
        messageText:
          "Oops, sorry, we couldn’t find that specific child. Would you consider one of these other precious children? They are all still waiting for a sponsor like you.",
        classList: ["alert alert-danger grid-message"],
        icon: true,
        iconType: faTimesCircle,
      });
      this.props.handleBackButton();
      return;
      // this.props.toggleDetailView(false);
    }
    if (this.props.check_child_available && (this.props.child[this.props.childId].lockIdentifier != null || this.props.child[this.props.childId].availableFlag === false )) {
      let message_text = "But these other children would love a sponsor like you!";
      let gender_translation = "";
      this.props.child[this.props.childId].gender === "Female"
        ? (gender_translation = "girl")
        : (gender_translation = "boy");
      if (this.props.child_unavailable.child_unavailable_search_method === "gender") {
        message_text = `But these other ${gender_translation}s would love a sponsor like you!`;
      }
      if (this.props.child_unavailable.child_unavailable_search_method === "countryCodes") {
        message_text = `But these other children from ${this.state.childCountry} would love a sponsor like you!`;
      }
      this.props.checkChildLocked(
        true,
        this.props.child[this.props.childId].identifier,
        this.props.child_unavailable.child_unavailable_search_method
      );
      this.props.toggleErrorMessage(true, {
        messageText: `Good news! It looks like ${
          this.state.childName
        } might already be matched with a sponsor. ${message_text}`,
        classList: ["alert alert-info--light grid-message"],
        icon: true,
        iconType: faExclamationCircle,
      });
      this.props.handleBackButton();
    }
  }

  renderChildTile(screenSize1="", screenSize2=""){
    const childName = (this.props.child[this.props.childId]) ? this.props.child[this.props.childId].givenName : (this.props.givenName) ? this.props.givenName : "Me";

    if(this.props.device == screenSize1 || this.props.device == screenSize2){

      const donateLink = donateLinkBuilder(this.state, this.props.failover, this.props.failoverCallbackUrl, this.props.appConfigs.settings);
      return(<section className="col1">
              <section className={`detail__tile-container`}>
                <ChildTile
                  urlLink={donateLink}
                  childDetail={true}
                  {...this.props.child[this.props.childId]}
                  sponsorshipTileCtaText={`Sponsor ${childName}`}
                  // These are magic numbers to prevent console errors from the child tile expecting grid variables
                  gridVars={{ rowGap: 16, rowSpanRatio: 40 }}
                  extraClasses={[""]}
                  device={this.props.device}
                  fireAddToCart={true}
                  descriptorsReceived={this.props.descriptorsReceived}
                  descriptorIndex={this.props.descriptorIndex || 0}
                  gridView={false}
                  classList=""
                  id={1}
                />
                <ShareChild
                  child={this.props.child[this.props.childId]}
                  linkToCopy={`${document.location.origin}${document.location.pathname}?childItem=${
                    this.props.childId
                  }`}
                />
              </section>
            </section>
      );
    }
  }

  render() {
    if (this.props.status == "COMPLETE") {
      const additionalParams = getAdditionalParams();
      const donateLink = donateLinkBuilder(this.state, this.props.failover, this.props.failoverCallbackUrl, this.props.appConfigs.settings) + additionalParams;
      const childName = this.props.device === "tablet" || this.props.device === "mobile" 
        ? (
           <ChildName device={this.props.device} {...this.state} />
          ) 
        : null;

      const sponsorMe =
        this.props.device === "tablet" || this.props.device === "mobile" ? (
          <SponsorCta
            fireAddToCart={true}
            urlLink={donateLink}
            classList={["btn", "btn-primary", "cta-link"]}
            sponsorshipTileCtaText={`Sponsor Me`}
            angleRight={false}
            childInfoProps={this.props.child[this.props.childId]}
            {...this.props.child[this.props.childId]}
          />
        ) : null;
      const sponsorMeDesk =
        this.props.device === "desktop" ? (
          <SponsorCta
            fireAddToCart={true}
            urlLink={donateLink}
            classList={["btn", "btn-primary", "cta-link"]}
            sponsorshipTileCtaText={`Sponsor Me`}
            angleRight={true} 
            childInfoProps={this.props.child[this.props.childId]}
            {...this.props.child[this.props.childId]}
          />
        ) : null;
      const childObject = this.props.child[this.props.childId];

      return (
        <div className="child-detail container">
          <section className="detail__header">

            {this.renderBackLink()}
            {childName}
          </section>
          <section className={`child-detail__content ${this.props.loading_class}`}>
            {this.renderChildTile("desktop")}
            <section className="main-content col2">
              <ChildVideo
                videoUrl={this.state.videoUrl}
                device={this.props.device}
                videoLanguage={this.state.videoLanguage}
                videoText="I speak"
                showLanguage={true}
                loop="loop"
              />

              {sponsorMe}
              {this.renderChildTile("tablet", "mobile")}

              <ChildStory story={this.state.story} childImage={this.state.childImage} device={this.props.device} />
              <SponsorValue price={this.props.price} />
              <ChildBenefits />
              <div className="cta-wrapper child-detail__item">
                <div className="child-detail__explore-more-children">{this.renderExploreMoreLink()}</div>
                {sponsorMeDesk}
              </div>
            </section>
          </section>
        </div>
      );
    }
    // else if (this.props.status == "ERROR") {
    //   return (
    //     <div>
    //       <p>We were unable to find the child you're searching for.</p>
    //       <BackButton
    //         classList={"detail__back-to-grid btn-text btn-text-blue btn-small"}
    //         buttonText="Find someone wonderful to sponsor."
    //         handleBackButton={this.props.handleBackButton}
    //         resetGridCalc={this.props.resetGridCalc}
    //         handleHistory={this.props.handleHistory}
    //       />
    //     </div>
    //   );
    // }
    else {
      return (
        <div className="spinner--wv-star">
          <div className="double-bounce1" />
          <div className="double-bounce2" />
        </div>
      );
    }
  }
}

// Get apps state and pass it as props to UserList
//      > whenever state changes, the UserList will automatically re-render
function mapStateToProps(state) {
  return {
    ...state,
    formRequest: state.children,
  };
}

// Get actions and pass them as props to to UserList
//      > now UserList has this.props.selectUser
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      // getChildren: getChildren,
      // searchMethodUpdater: searchMethodUpdater,
      getChildById: getChildById,
      // getChildStoryById: getChildStoryById,
      statusUpdater: statusUpdater,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ChildDetail);
